import ArticleLayout from "../components/ArticleLayout";

export default function JacketsGuide() {
  return <ArticleLayout articleId={9} />;
}